import * as React from 'react';

import cx from 'classnames';
import { capitalize } from 'lodash';

import Checkbox from 'components/Checkbox';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import EventTracking from 'lib/EventTracking';
import IndividualRecipientAvatar from 'chat_v2/components/IndividualRecipientAvatar';

import { ComposerContext, UIEventContext } from './ComposerContext';
// @ts-ignore
import { DisabledTooltipLayer } from './SelectFromList';

import { ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity } from 'chat_v2/components/SplitComposer/queries/__generated__/ComposerRecipients';
import { ComposerDispatchContext } from 'chat_v2/ComposerContext';

type Props = {
  entity: ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity;
  recipientIsSelected: boolean;
  disabledCopy?: React.ReactNode;
};

export default class IndividualRecipientItem extends React.Component<Props> {
  logSelectionEvent = (uiEventContext: UIEventContext) => {
    if (this.props.recipientIsSelected) {
      EventTracking.trackKey('announcements.share_to.individual.unselect.click', uiEventContext);
      return;
    }
    EventTracking.trackKey('announcements.share_to.individual.select.click', uiEventContext);
  };

  render() {
    const { entity , disabledCopy, recipientIsSelected } = this.props;
    const { content, recipient } = entity;

    const component = (
      <ComposerDispatchContext.Consumer>
        {composerDispatch => (
          <ComposerContext.Consumer>
            {composerContext => { 
              const selectionHandler = (event: React.ChangeEvent<HTMLInputElement> | React.MouseEvent) => {
                event.preventDefault();

                this.logSelectionEvent(composerContext.getUIEventContext());
                
                if (recipientIsSelected) {
                  composerDispatch({ type: 'removeRecipient', uuid: recipient.uuid });
                } else {
                  composerDispatch({ type: 'addRecipient', entity });
                }
              };

              return (
                <li
                  className={cx('RecipientItem', {
                    'RecipientItem--disabled': !!disabledCopy,
                  })}
                  onClick={selectionHandler}
                  data-test-selector={`split-composer-individual-${recipient.uuid}`}>
                  <MediaObject figure="right" center>
                    <MediaObject gutter="small" center>
                      <IndividualRecipientAvatar size="medium" entity={entity} /> 
                      <div>
                        <Text size="small" element="div" truncate>
                          {content.title}
                        </Text>
                        <Text size="xsmall" element="div" color="graphite">
                          {capitalize(content.info || '')}
                        </Text>
                      </div>
                    </MediaObject>
                    <Checkbox onChange={selectionHandler} checked={recipientIsSelected} />
                  </MediaObject>
                </li>
            )}}
          </ComposerContext.Consumer>
        )}
      </ComposerDispatchContext.Consumer>
    );
    return disabledCopy ? (
      <DisabledTooltipLayer text={disabledCopy}>{component}</DisabledTooltipLayer>
    ) : (
      component
    );
  }
}
